import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useParams } from "react-router-dom";
import "./Blog.css";
import { blogPosts } from "./blogData";

const BlogDetails = () => {
    const { slug } = useParams();
    const blog = blogPosts.find((post) => post.slug === slug);
    const heroImage = blog?.content.match(/<img[^>]+src="([^"]+)"/)?.[1];

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [slug]);

    if (!blog) {
        return (
            <section className="blog-page">
                <article className="full-blog blog-not-found">
                    <span className="blog-category">PRT ACADEMY BLOG</span>
                    <h1>Article not found</h1>
                    <p className="blog-subtitle">
                        The blog link may be incorrect or the article may have moved.
                    </p>
                    <Link className="back-button" to="/blog">
                        &larr; Back to Blogs
                    </Link>
                </article>
            </section>
        );
    }

    return (
        <>
            <Helmet>
                <title>{blog.title} | PRT Academy</title>
                <meta name="description" content={blog.excerpt} />
                <link
                    rel="canonical"
                    href={`${window.location.origin}/blog/${blog.slug}`}
                />
            </Helmet>

            <div className="blog-details-page">
                <section
                    className="blog-details-hero"
                    style={heroImage ? { backgroundImage: `url(${heroImage})` } : undefined}
                >
                    <div className="blog-details-hero-overlay" />
                    <div className="blog-details-hero-content">
                        <span className="blog-category">{blog.category}</span>
                        <h1>{blog.title}</h1>
                        <p>{blog.excerpt}</p>
                    </div>
                </section>

                <main className="blog-details-container">
                    <Link className="back-button" to="/blog">
                        &larr; Back to Blogs
                    </Link>

                    <article className="blog-article">
                        <div className="blog-introduction">
                            <span className="article-label">INTRODUCTION</span>
                            <p>{blog.excerpt}</p>
                            <p>
                                This PRT Academy guide brings the complete article,
                                practical guidance, images, section navigation, and
                                frequently asked questions together in one place.
                            </p>
                        </div>

                        <div className="blog-content-area">
                            <div className="article-label">COMPLETE GUIDE</div>
                            <div dangerouslySetInnerHTML={{ __html: blog.content }} />
                        </div>
                    </article>
                </main>

                <section className="blog-details-cta">
                    <span>BUILD YOUR IT CAREER</span>
                    <h2>Learn, Build, and Grow With PRT Academy</h2>
                    <p>
                        Explore practical courses, projects, mentorship, and career
                        preparation for your next step in IT.
                    </p>
                    <Link to="/courses">Explore PRT Academy Courses</Link>
                </section>

            </div>
        </>
    );
};

export default BlogDetails;
